export default __webpack_public_path__ + "media/images/oak-rise-plot-1-hr-c86031d7c88c226a3dd07839c243020e.png";